import React, { useContext } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { EVENT_PROPERTIES_VALUES } from "../../types/Amplitude";

// Components
import IconButton from "../Atoms/IconButton";
import { TrackingContext } from "../Utils/TrackingWrapper";

// Stylesheets
import "./Backdrop.scss";

const onClick =
  ({ handleHide, trackCloseCart, pageUrl }) =>
  () => {
    trackCloseCart({
      pageUrl,
      action: EVENT_PROPERTIES_VALUES.Cart_Backdrop_Clicked,
      sectionName: EVENT_PROPERTIES_VALUES.Cart,
    });

    handleHide();
  };

export const Backdrop = ({ isVisible, handleHide, ariaLabel }) => {
  const {
    trackingActions: { trackCloseCart },
    pageUrl,
  } = useContext(TrackingContext);
  const className = classNames("backdrop", { is_visible: isVisible });

  // let backdropContentTop = 84;
  // if (document.getElementById('j-why-to-buy-exists')) {
  //   backdropContentTop += document.getElementById('j-why-to-buy-exists').clientHeight;
  // }
  // if (document.getElementsByClassName('ribbon').length > 0) {
  //   backdropContentTop += document.getElementsByClassName('ribbon')[0].clientHeight;
  // }

  const renderBackdropContents = () => {
    if (isVisible) {
      return (
        <IconButton
          ariaLabel={ariaLabel}
          className="close_button"
          onClick={onClick({ trackCloseCart, pageUrl, handleHide })}
        >
          <div
            className={"backdrop_content"}
            // style={{top: `${backdropContentTop}px`}}
          />
        </IconButton>
      );
    }

    return null;
  };

  return <div className={className}>{renderBackdropContents()}</div>;
};

Backdrop.propTypes = {
  isVisible: PropTypes.bool,
  handleHide: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
};

export default Backdrop;
